export default "__VITE_ASSET__390caeff__"